import { render, staticRenderFns } from "./VibrationWaterfallBox.vue?vue&type=template&id=dafca942&scoped=true&"
import script from "./VibrationWaterfallBox.vue?vue&type=script&lang=ts&"
export * from "./VibrationWaterfallBox.vue?vue&type=script&lang=ts&"
import style0 from "./VibrationWaterfallBox.vue?vue&type=style&index=0&id=dafca942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafca942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VIcon,VSelect,VTextField})
